import * as z from "zod"
import { ExpiryReason } from "@prisma/client"

export const RouteModel = z.object({
  id: z.number().int(),
  created_at: z.date(),
  updated_at: z.date(),
  provider_id: z.string(),
  origin_airport_id: z.string(),
  destination_airport_id: z.string(),
  expiry_reason: z.nativeEnum(ExpiryReason).nullish(),
  expiry_comment: z.string().nullish(),
  path: z.string(),
})
